/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ScanFrameTextIcon16Light } from './ScanFrameTextIcon16Light';
import { ScanFrameTextIcon16Regular } from './ScanFrameTextIcon16Regular';
import { ScanFrameTextIcon16Solid } from './ScanFrameTextIcon16Solid';
import { ScanFrameTextIcon20Light } from './ScanFrameTextIcon20Light';
import { ScanFrameTextIcon20Regular } from './ScanFrameTextIcon20Regular';
import { ScanFrameTextIcon20Solid } from './ScanFrameTextIcon20Solid';
import { ScanFrameTextIcon24Regular } from './ScanFrameTextIcon24Regular';
import { ScanFrameTextIcon24Solid } from './ScanFrameTextIcon24Solid';
import { ScanFrameTextIcon32Regular } from './ScanFrameTextIcon32Regular';
import { ScanFrameTextIcon64Regular } from './ScanFrameTextIcon64Regular';
var sizes = {
    16: {
        light: ScanFrameTextIcon16Light,
        regular: ScanFrameTextIcon16Regular,
        solid: ScanFrameTextIcon16Solid,
    },
    20: {
        light: ScanFrameTextIcon20Light,
        regular: ScanFrameTextIcon20Regular,
        solid: ScanFrameTextIcon20Solid,
    },
    24: {
        regular: ScanFrameTextIcon24Regular,
        solid: ScanFrameTextIcon24Solid,
    },
    32: {
        regular: ScanFrameTextIcon32Regular,
    },
    64: {
        regular: ScanFrameTextIcon64Regular,
    },
};
export var ScanFrameTextIcon = forwardRef('ScanFrameTextIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
